import * as types from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_PASSPORT_VISA_DETAIL:
      return { [action.payload.EmployeeId]: action.payload };
    case types.CREATE_PASSPORT_VISA_DETAIL:
      return { ...state, [action.payload.EmployeeId]: action.payload };
    case types.EDIT_PASSPORT_VISA_DETAIL:
      return { ...state, [action.payload.EmployeeId]: action.payload };
    default:
      return state;
  }
};
